import React from "react";

export interface InputProps
    extends React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
    name: string;
    uppercase?: boolean;
}

const Input: React.FC<InputProps> = ({
    className = "field-control__input",
    autoComplete = "off",
    type = "text",
    placeholder = " ",
    uppercase = false,
    ...props
}) => {
    return (
        <input
            className={`${className}${uppercase ? " field-control__input--uppercase" : ""}`}
            autoComplete={autoComplete}
            type={type}
            placeholder={placeholder}
            {...props}
        />
    );
};

export default Input;
